import React from 'react';
import QuestionnaireNodeForm from 'routes/surface/components/node-modal-form/components/questionnaire-node-modal/components/questionnaire-node-form';
import { useOnSurfaceNodeSave } from 'components/canvas/hooks/use-on-surface-node-save';
import useSurfaceNodeInitialValuesFromServer from 'routes/surface/components/node-modal-form/hooks/use-surface-node-initial-values-from-server';
import useSaveNodeInCache from 'components/canvas/hooks/use-save-node-in-cache';
import useMutation from 'hooks/use-mutation';
import { createSurfaceQuestionnaireNodeMutation } from 'graphql/surface-node/mutations/surface-questionnaire-node/create-surface-questionnaire-node';
import { updateSurfaceQuestionnaireNodeMutation } from 'graphql/surface-node/mutations/surface-questionnaire-node/update-surface-questionnaire-node';
import { toast } from 'services/toast';
import { pick } from 'lodash';
import { ModalContext } from 'hoc/with-modal';
import { withModal } from 'hoc';
import { NodeModalInput, Position } from 'types';
import { SurfaceQuestionnaireNode } from 'graphql/types';

export interface QuestionnaireNodeModalProps {
  data: NodeModalInput<SurfaceQuestionnaireNode>;
  modal: ModalContext;
}

const defaultProps = {};

function QuestionnaireNodeModal(props: QuestionnaireNodeModalProps) {
  const { initialValues: data } = useSurfaceNodeInitialValuesFromServer(
    props.data,
  );

  // @ts-ignore
  const surfaceId = data.surface?.id ?? data.surface;

  const saveNodeInCache = useSaveNodeInCache();

  const onSurfaceNodeCreate = useOnSurfaceNodeSave(
    'createSurfaceQuestionnaireNode',
  );

  const onSurfaceNodeUpdate = useOnSurfaceNodeSave(
    'updateSurfaceQuestionnaireNode',
  );

  const [createSurfaceNode] = useMutation(
    createSurfaceQuestionnaireNodeMutation,
    {
      update: onSurfaceNodeCreate as any,
    },
  );

  const [updateSurfaceNode] = useMutation(
    updateSurfaceQuestionnaireNodeMutation,
    {
      update: onSurfaceNodeUpdate as any,
    },
  );

  function onSubmit(values, { setSubmitting }) {
    const saveOperation = data.id ? updateSurfaceNode : createSurfaceNode;

    const keys = data.id
      ? ['id', 'name', 'question', 'answerType']
      : ['name', 'surface', 'position', 'question', 'answerType'];

    const input = pick(values, keys);

    return saveOperation({ variables: { input } }).then((response) => {
      if (response.isFailure) {
        setSubmitting(false);
        toast.error(response.getErrorMessage());

        return response;
      }

      props.modal.hide();

      return response;
    });
  }

  return (
    <QuestionnaireNodeForm
      onSubmit={onSubmit}
      data={data}
      onCancel={props.modal.hide}
      saveNodeInCache={saveNodeInCache}
    />
  );
}

QuestionnaireNodeModal.defaultProps = defaultProps;

export default withModal(QuestionnaireNodeModal);
